import React, { useEffect } from "react";

import { captureUtm } from "../../hooks/useUtmCapture";
import { trackWhatsApp, buildWhatsAppText } from "../../utils/tracking";

// Link de divulgação do recrutamento de motoristas (/recrutamento-motorista): abre direto o WhatsApp do recrutamento da GH, sem clique.
const RECRUITMENT_PHONE = "554792204260";
const RECRUITMENT_MESSAGE =
  "Olá! Vi o anúncio de vocês e tenho interesse em me candidatar para a vaga de motorista.\n\n" +
  "Tenho experiência na área, CNH em dia e total disponibilidade. Como faço para enviar o meu currículo e participar do processo seletivo?\n\n" +
  "Fico no aguardo. Obrigado!";
// Tempo para o GTM/GA registrarem a visita antes de sair da página.
const REDIRECT_DELAY_MS = 300;

function buildRecruitmentUrl() {
  return `https://wa.me/${RECRUITMENT_PHONE}?text=${buildWhatsAppText(RECRUITMENT_MESSAGE)}`;
}

function Recruitment() {
  useEffect(() => {
    // O efeito do App que grava as UTMs roda depois deste; captura aqui para a origem entrar na mensagem.
    captureUtm();
    trackWhatsApp("recrutamento_redirect");

    // replace: o "voltar" do navegador não cai de novo neste redirecionamento.
    const timer = setTimeout(() => window.location.replace(buildRecruitmentUrl()), REDIRECT_DELAY_MS);
    return () => clearTimeout(timer);
  }, []);

  return (
    <main
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "12px",
        padding: "16px",
        textAlign: "center",
        background: "#093390",
        color: "#ffffff",
        fontFamily: "inherit",
      }}
    >
      <p style={{ margin: 0, fontSize: "1.25rem" }}>Abrindo o WhatsApp do recrutamento da GH...</p>
      <a href={buildRecruitmentUrl()} style={{ color: "#FF6700", fontWeight: 700 }}>
        Se não abrir automaticamente, clique aqui.
      </a>
    </main>
  );
}

export default Recruitment;
